import { render, staticRenderFns } from "./RequestTickets.vue?vue&type=template&id=3c181322&scoped=true&"
import script from "./RequestTickets.vue?vue&type=script&lang=js&"
export * from "./RequestTickets.vue?vue&type=script&lang=js&"
import style0 from "./RequestTickets.vue?vue&type=style&index=0&id=3c181322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c181322",
  null
  
)

export default component.exports